import { iconClasses, iconButtonClasses } from "@mui/material"
import { makeStyles } from "tss-react/mui"

export const useStyles = makeStyles<{ isMobile?: boolean }>()(
  ({ spacing, shape, typography, palette, mixins }, { isMobile }) => ({
    highlightContainer: {
      display: "flex",
      flexDirection: isMobile ? "row" : "column",
      backgroundColor: palette.primary[800],
      borderRadius: shape.borderRadius * 1.5,
      padding: spacing(1),
      gap: spacing(1),
      color: palette.primary[300]
    },
    highlightAction: {
      [`&.${iconButtonClasses.root}`]: {
        borderRadius: "3px",
        color: palette.primary[300],
        backgroundColor: "transparent",

        "&:hover": {
          backgroundColor: palette.primary[600],
          color: palette.common.white
        },

        // a11y: white focus ring on mouse + keyboard for the dark toolbar; the inherited blue ring fails 3:1 here (SC 1.4.11)
        "&:focus, &:focus-visible": {
          ...mixins.focusRingOnDark.shadow,
          boxShadow: `${mixins.focusRingOnDark.shadow.boxShadow} !important`
        },

        "&.active": {
          backgroundColor: palette.secondary[600],
          color: palette.common.white,
          border: "3px solid transparent",

          "&:hover": {
            backgroundColor: palette.secondary[600]
          }
        }
      }
    },
    draggableIcon: {
      width: isMobile ? typography.pxToRem(26) : typography.pxToRem(36),
      height: typography.pxToRem(36),
      borderRadius: "3px",
      cursor: "grab",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",

      ":hover, :focus-visible": {
        [`.${iconClasses.root}`]: {
          color: palette.common.white
        }
      },

      // a11y: white focus ring on mouse + keyboard for the focusable drag handle on the dark toolbar (SC 1.4.11, 2.4.7)
      "&:focus, &:focus-visible": {
        ...mixins.focusRingOnDark.shadow,
        boxShadow: `${mixins.focusRingOnDark.shadow.boxShadow} !important`
      }
    }
  })
)
